import {NgModule} from '@angular/core';
import {UnsavedChangesNotifierService} from '@application/helper/unsaved-changes-notifier/unsaved-changes-notifier.service';
import {TextileDataSharedModule} from '@presentation/pages/textile-data/textile-data-shared.module';
import {SharedModule} from '@shared/shared.module';
import {CanShowErrorForFormControlModule} from '@vdw/angular-component-library';
import {AgGridModule} from 'ag-grid-angular';
import {AddTuftProductPageComponent} from './add/add-tuft-product-page.component';
import {TuftProductOverviewPageComponent} from './overview/tuft-product-overview-page.component';
import {tuftProductRouting} from './tuft-product.routing';

@NgModule({
  imports: [TextileDataSharedModule, SharedModule, AgGridModule, tuftProductRouting, CanShowErrorForFormControlModule],
  declarations: [TuftProductOverviewPageComponent, AddTuftProductPageComponent],
  providers: [UnsavedChangesNotifierService]
})
export class TuftProductModule {}
